import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { itIT } from "@mui/material/locale";
import "../fontStyle.css"; // Import dei font Google esistenti


export const natureTheme = responsiveFontSizes(
    createTheme(
        {
            // CONFIGURAZIONE FONT - Temi naturali e organici
            typography: {
                // Font generale: Source Sans Pro (pulito e leggibile, ottimo per temi naturali)
                fontFamily: [
                    "Source Sans Pro", // Font principale naturale
                    "Roboto", // Fallback se Source Sans Pro non carica
                    "Segoe UI",
                    "Arial",
                    "sans-serif",
                ].join(","),

                // Headers con Playfair Display (elegante, serif naturale)
                h1: {
                    fontFamily: "Playfair Display",
                    fontWeight: 600,
                    letterSpacing: "-0.02em",
                },
                h2: {
                    fontFamily: "Playfair Display",
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                },
                h3: {
                    fontFamily: "Playfair Display",
                    fontWeight: 500,
                },
                h4: {
                    fontFamily: "Source Sans Pro",
                    fontWeight: 600,
                },
                h5: {
                    fontFamily: "Source Sans Pro",
                    fontWeight: 600,
                },
                h6: {
                    fontFamily: "Source Sans Pro",
                    fontWeight: 500,
                },

                // Testo speciale con Crimson Text (serif per citazioni/accenti)
                subtitle1: {
                    fontFamily: "Crimson Text",
                    fontWeight: 400,
                    fontStyle: "italic",
                },
                subtitle2: {
                    fontFamily: "Crimson Text",
                    fontWeight: 400,
                },

                // Button con Source Sans Pro
                button: {
                    fontFamily: "Source Sans Pro",
                    fontWeight: 600,
                    letterSpacing: "0.02em",
                },
            },

            // CONFIGURAZIONE PALETTE - Colori naturali
            palette: {
                mode: "light",

                // Verde salvia come primario
                primary: {
                    main: "#8FBC8F", // Dark Sea Green
                    dark: "#556B2F", // Dark Olive Green
                    light: "#C8E6C9", // Light Green
                },

                // Beige caldo come secondario
                secondary: {
                    main: "#D2B48C", // Tan
                    dark: "#A0522D", // Sienna
                    light: "#F5E6D3", // Beige chiaro
                },

                // Testi in toni naturali
                text: {
                    primary: "#2E4B27", // Verde scuro per testo principale
                    secondary: "#6B7A67", // Verde grigiastro per testo secondario
                },

                // Stati con colori naturali
                error: {
                    main: "#D2691E", // Chocolate (più naturale del rosso)
                },
                info: {
                    main: "#4682B4", // Steel Blue (blu naturale)
                },
                success: {
                    main: "#228B22", // Forest Green
                },
                warning: {
                    main: "#DAA520", // Goldenrod
                },

                // Divisori sottili
                divider: "rgba(107, 122, 103, 0.3)", // Verde grigiastro trasparente

                // Sfondi naturali
                background: {
                    default: "#F8F6F0", // Crema molto chiaro
                    paper: "#FFFFFF", // Bianco puro per le card
                },

                // Azioni con colori naturali
                action: {
                    hover: "rgba(143, 188, 143, 0.08)", // Verde salvia trasparente
                    selected: "rgba(143, 188, 143, 0.12)",
                },
            },

            // CONFIGURAZIONE FORME - Morbide e organiche
            shape: {
                borderRadius: 12, // Bordi morbidi
            },

            // CONFIGURAZIONE COMPONENTI
            components: {
                // BUTTON con stile naturale
                MuiButton: {
                    styleOverrides: {
                        root: {
                            borderRadius: 12,
                            fontWeight: 600,
                            textTransform: "none", // Testo naturale, non tutto maiuscolo
                            padding: "10px 24px",
                            letterSpacing: "0.02em",
                        },
                        contained: {
                            boxShadow: "0 4px 12px rgba(143, 188, 143, 0.25)", // Ombra verde naturale
                            "&:hover": {
                                boxShadow: "0 6px 16px rgba(143, 188, 143, 0.35)",
                                transform: "translateY(-1px)", // Effetto leggero
                            },
                        },
                        outlined: {
                            borderWidth: "2px",
                            "&:hover": {
                                borderWidth: "2px",
                                backgroundColor: "rgba(143, 188, 143, 0.05)",
                            },
                        },
                    },
                },

                // CARD con ombre naturali
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 16,
                            boxShadow: "0 4px 20px rgba(46, 75, 39, 0.08)", // Ombra verde scura sottile
                            "&:hover": {
                                boxShadow: "0 8px 30px rgba(46, 75, 39, 0.12)",
                            },
                        },
                    },
                },

                // TEXTFIELD organici
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 12,
                                "& fieldset": {
                                    borderColor: "rgba(143, 188, 143, 0.5)",
                                },
                                "&:hover fieldset": {
                                    borderColor: "rgba(143, 188, 143, 0.8)",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#8FBC8F",
                                },
                            },
                        },
                    },
                },

                // CHIP naturali
                MuiChip: {
                    styleOverrides: {
                        root: {
                            borderRadius: 20,
                        },
                    },
                },
            },

            // COLORI CUSTOM per il tema naturale
            andonStatoPagamento: {
                inLavorazione: "#DAA520", // Goldenrod
                daRichiedere: "#4682B4", // Steel Blue
                inAttesaPagamento: "#DEB887", // Burlywood
                parzialmentePagato: "#C8E6C9", // Light Green
                pagato: "#228B22", // Forest Green
                annullato: "#A9A9A9", // Dark Gray
            },
            coloriFiltro: {
                attivo: "#8FBC8F", // Dark Sea Green
                disattivo: "#F5E6D3", // Beige chiaro
            },
        },
        itIT
    )
);